import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from 'modules/ui';
import * as dataActions from 'modules/fetchData';
import Gallery from 'components/Lookbook/Gallery';

export default connect(
    (state) => ({
        color: state.ui.get('color'),
        setGallery: state.ui.get('setGallery'),
        lookbookData: state.fetchData.get('lookbook').toJS(),
        galleryIndex: state.ui.get('galleryIndex')
    }),
    (dispatch) => ({
        UIActions: bindActionCreators(uiActions, dispatch),
        DataActions: bindActionCreators(dataActions, dispatch)
    })
)(Gallery);




// WEBPACK FOOTER //
// ./src/containers/GalleryContainer.js